import { Col, Flex, Grid, Row, theme } from "antd";
import React from "react";

import {
  LocationAddressCityRegion,
  LocationAddressStreet,
  LocationGetDirections,
  LocationHours,
  LocationName,
  LocationNameLink,
  LocationPhone,
  LocationRentNowButton,
  LocationViewLocationButton,
} from "./components";
import {
  LocationButtonContainer,
  LocationCardContainer,
  RowLocationCta,
  Skeleton,
} from "./styled";
import { LocationCardComponent } from "./types";

import { SolutionSlug } from "~/Atom/SolutionIcon/types";
import { SolutionTag } from "~/Atom/SolutionTag";
import { sortMarketsBySolutionSortOrder } from "~/utils";

export const LocationCard: LocationCardComponent = ({
  location: loc,
  popup,
  distanceCenter,
  active,
  hoverStyles,
  ...rest
}) => {
  const { token } = theme.useToken();
  const breakpoints = Grid.useBreakpoint();

  const isMobilePopup = popup && !breakpoints.sm;

  return (
    <LocationCardContainer
      $token={token}
      $breakpoints={breakpoints}
      $popup={popup}
      $onClick={Boolean(rest.onClick)}
      $active={active}
      $hoverStyles={hoverStyles}
      className="fadeInFast"
      data-testid={`location-card-${loc ? "loaded" : "loading"}`}
      data-location-slug={loc?.slug}
      {...rest}
    >
      <Row style={{ marginBottom: "0.5rem" }}>
        <Col xs={24}>
          {!loc ? (
            <Skeleton
              size="small"
              style={{
                width: "25rem",
                maxWidth: "75%",
              }}
            />
          ) : rest.onClick ? (
            <LocationName location={loc} popup={popup} />
          ) : (
            <LocationNameLink location={loc} popup={popup} />
          )}
        </Col>
      </Row>
      {!isMobilePopup && (
        <Row style={{ marginBottom: "0.5rem" }}>
          <Col xs={24}>
            <Flex gap="small" wrap={true}>
              {loc?.markets
                .sort(sortMarketsBySolutionSortOrder)
                .map(({ solution: { slug } }) => (
                  <SolutionTag key={slug} solutionSlug={slug as SolutionSlug} />
                ))}
            </Flex>
          </Col>
        </Row>
      )}

      <Row>
        <Col xs={24} sm={15}>
          {!loc ? (
            <Flex gap="small">
              <Skeleton
                size="small"
                style={{
                  width: "8rem",
                  maxWidth: "75%",
                }}
              />
            </Flex>
          ) : (
            <React.Fragment>
              <LocationAddressStreet location={loc} popup={popup} />
              <LocationAddressCityRegion location={loc} popup={popup} />
            </React.Fragment>
          )}
        </Col>
        {!isMobilePopup && (
          <Col xs={24} sm={9} style={{ textAlign: "right" }}>
            {!loc ? (
              <Skeleton size="small" style={{ width: "6rem" }} />
            ) : (
              <LocationHours location={loc} />
            )}
          </Col>
        )}
      </Row>

      <RowLocationCta>
        <Col
          xs={isMobilePopup ? 24 : 12}
          style={{
            verticalAlign: "middle",
          }}
        >
          {!loc ? (
            <Skeleton size="small" style={{ width: "8rem" }} />
          ) : (
            <LocationGetDirections
              location={loc}
              distanceCenter={distanceCenter}
              popup={popup}
            />
          )}
        </Col>
        <Col
          xs={isMobilePopup ? 24 : 12}
          style={{
            textAlign: !loc ? "right" : "left",
            verticalAlign: "middle",
            marginTop: isMobilePopup ? "0.5rem" : undefined,
          }}
        >
          {!loc ? (
            <Skeleton size="small" style={{ width: "8rem" }} />
          ) : (
            <LocationPhone location={loc} popup={popup} />
          )}
        </Col>
      </RowLocationCta>

      <Row>
        <LocationButtonContainer>
          {!loc ? (
            <React.Fragment>
              {!popup && <Skeleton size="small" block={true} />}
              <Skeleton size="small" block={true} />
            </React.Fragment>
          ) : (
            <React.Fragment>
              {!popup && <LocationRentNowButton location={loc} />}
              <LocationViewLocationButton location={loc} popup={popup} />
            </React.Fragment>
          )}
        </LocationButtonContainer>
      </Row>
    </LocationCardContainer>
  );
};
